<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <!-- support button Anfang -->
  <div>
    <v-menu
      v-if="isLogin"
      transition="slide-x-transition"
      v-model="showMenu"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-card color="#8ACAC1" class="pointer supportButton pr-3 pt-3">
          <v-btn flat icon v-on="on" color="white" large class="ml-2">
            <v-icon large>perm_phone_msg</v-icon>
          </v-btn>

        </v-card>
        <!--<v-avatar size="93" color="#8ACAC1" v-on="on" class="pointer supportButton pr-3 pt-3">
          <v-icon dark large>perm_phone_msg</v-icon>
        </v-avatar>-->
      </template>

      <v-card width="250px" flat>
        <v-card color="blue" class="title pa-2 pl-3 font-weight-thin white--text text-xs-left">
          {{'SUPPORT_TITLE' | translate}}
        </v-card>
        <v-card-title class="body-2 bluetext">
          <v-icon color="#004884">phone</v-icon>&nbsp;&nbsp;&nbsp; <a href="tel:+492131109626" style="text-decoration: none"><span v-html="$t('TELEPHONE')"></span> </a>
        </v-card-title>
        <v-card-title class="body-2 bluetext">
          <v-icon color="#004884">email</v-icon> &nbsp;&nbsp;&nbsp; <a href="mailto:info@evaluerate.de" style="text-decoration: none"><span v-html="$t('FOOTER_MAILADDRESS')"></span> </a>
        </v-card-title>
      </v-card>
    </v-menu>






    <v-menu
      v-if="!isLogin"
      transition="slide-x-transition"
      v-model="showMenu"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-card color="#8ACAC1" class="pointer supportButton pr-3 pt-3">
          <v-btn flat icon v-on="on" color="white" large class="ml-2">
            <v-icon large>perm_phone_msg</v-icon>
          </v-btn>

        </v-card>
        <!--<v-avatar size="93" color="#8ACAC1" v-on="on" class="pointer supportButton pr-3 pt-3">
          <v-icon dark large>perm_phone_msg</v-icon>
        </v-avatar>-->
      </template>

      <v-card width="600px" flat>
        <v-card color="blue" class="title pa-2 pl-3 font-weight-thin white--text text-xs-left">
          {{'SUPPORT_TITLE' | translate}}
        </v-card>
        <v-card flat>
          <v-layout row justify-start>
            <v-card-title class="body-2 bluetext">
              <v-icon color="#004884">phone</v-icon>&nbsp;&nbsp;&nbsp; <a href="tel:+492131109626" style="text-decoration: none"><span v-html="$t('TELEPHONE')"></span> </a>
            </v-card-title>
            <v-card-title class="body-2 bluetext">
              <v-icon color="#004884">email</v-icon> &nbsp;&nbsp;&nbsp; <a href="mailto:info@evaluerate.de" style="text-decoration: none"><span v-html="$t('FOOTER_MAILADDRESS')"></span> </a>
            </v-card-title>
          </v-layout>
          <ContactForm_Support @cancel="closeMenu" ref="myForm"/>
        </v-card>
      </v-card>
    </v-menu>

    <!--Button ende -->
  </div>
</template>

<script>
  import Vue from 'vue'
  import ContactForm_Support from './../widgets/ContactForm_Support'
  export default {
    name: 'BtnSupport',
    components: {ContactForm_Support},
    methods: {
      open : function() {
      },
      closeMenu : function () {
        Vue.prototype.$api.debug('closeMenu')
        this.showMenu = false
      },
      onLogin (login) {
        this.isLogin = !login
      },
      onSupportShow () {
        this.showMenu = true
        console.log('onSupportShow')
      }
    },
    watch: {
      showMenu: function (value) {
        this.showMenu = value
        if (this.$refs.myForm) {
          this.$refs.myForm.open()
        }
      }
    },
    data () {
      return {
        showMenu: false,
        isLogin: true
      }
    },
    mounted () {
      // this.isLogin = Vue.prototype.$api.getCredentials() !== null
    },
    created () {
      Vue.prototype.$eventHub.$on('OnLogin', this.onLogin)
      Vue.prototype.$eventHub.$on('OnSupportShow', this.onSupportShow)
    },
    destroyed () {
      Vue.prototype.$eventHub.$off('OnLogin', this.onLogin)
      Vue.prototype.$eventHub.$off('OnSupportShow', this.onSupportShow)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/BtnSupport.vue